import { Component } from '@angular/core';
import { ChatbotService } from './components/chatbot-ai/chatbot.service';
import { MainService } from 'src/app/app.service';

export interface AiChatQuestion {
  id: string;
  text: string;
  timestamp: Date;
}

export interface AiChatLiterals {
  welcomeMessage?: string;
  textAreaPlaceholder?: string;
  copyToClipboardButtonTitle?: string;
  copiedToClipboardButtonTitle?: string;
  likeButtonTitle?: string;
  dislikeButtonTitle?: string;
}

@Component({
  selector: 'app-query-chat',
  templateUrl: './query-chat.component.html',
  styleUrls: ['./query-chat.component.css']
})
export class QueryChatComponent {
  response: string = '';
  loading: boolean = false;
  literals: AiChatLiterals = {
    welcomeMessage: 'Olá! 👋 \n\nSou seu assistente de IA especializado em queries, infraestrutura e desenvolvimento. \n\nPosso ajudá-lo com análise de consultas SQL, configurações de ambiente (uso de memória/CPU) e questões de código ADVPL. \n\nComo posso auxiliá-lo hoje?',
    textAreaPlaceholder: 'Enviar uma mensagem',
    copyToClipboardButtonTitle: 'Copiar para área de transferência',
    copiedToClipboardButtonTitle: 'Copiado!',
    likeButtonTitle: 'Gostei',
    dislikeButtonTitle: 'Não Gostei'
  };

  constructor(
    private chatbotService: ChatbotService,
    private mainService: MainService
  ) {}

  onQuestion(question: AiChatQuestion) {
    this.loading = true;
    this.response = '';

    this.chatbotService.enviarPergunta(question.text)
      .subscribe({
        next: (resposta) => {
          if (resposta.error) {
            this.response = `Erro no envio da pergunta: por favor, tente novamente mais tarde ou contate o administrador.`;
            this.loading = false;
            return;
          }
          this.response = resposta.response;
          this.loading = false;
        },
        error: (msgError) => {
          this.mainService.handleError(msgError);
          this.loading = false;
        }
      });
  }
}
